import moment from "moment";

/**
 * Generación y descarga de CSV.
 *
 * La versión anterior concatenaba valores con comas sin escapar, así que un
 * nombre o una ciudad con coma desalineaba todas las columnas al abrir el
 * archivo en Excel.
 */

function escaparCampo(valor) {
  if (valor === null || valor === undefined) return "";
  const s = String(valor);
  // Sólo hace falta entrecomillar si el valor trae comas, comillas o saltos.
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

/**
 * @param {Array<{key: string, label: string, formato?: Function}>} columnas
 * @param {Array<Object>} filas
 */
export function construirCsv(columnas, filas) {
  const encabezado = columnas.map((c) => escaparCampo(c.label)).join(",");
  const cuerpo = filas.map((fila) =>
    columnas
      .map((c) => escaparCampo(c.formato ? c.formato(fila[c.key], fila) : fila[c.key]))
      .join(",")
  );
  return [encabezado, ...cuerpo].join("\n");
}

/**
 * Descarga el CSV. El BOM inicial es lo que hace que Excel en Windows respete
 * los acentos en lugar de mostrar "MÃ©xico".
 */
export function descargarCsv(nombreBase, columnas, filas) {
  const csv = "﻿" + construirCsv(columnas, filas);
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const enlace = document.createElement("a");
  enlace.href = url;
  enlace.download = `${nombreBase}_${moment().format("YYYY-MM-DD_HH-mm")}.csv`;
  document.body.appendChild(enlace);
  enlace.click();
  document.body.removeChild(enlace);
  URL.revokeObjectURL(url);
}
